import React, {Component} from 'react';
import styles from './StaticSiteMap.scss';

class StaticSiteMap extends Component {
  render() {
    const states = [
      {label:"New South Wales", state:"nsw"},
      {label:"Victoria", state:"vic"},
      {label:"Queensland", state:"qld"},
      {label:"Western Australia", state:"wa"},
      {label:"South Australia", state:"sa"},
      {label:"Northern Territory", state:"nt"},
      {label:"Tasmania", state:"tas"},
      {label:"Australian Capital Territory", state:"act"}
    ];

    const cities = [
      {label:"Sydney", urlatom:"sydney", state:"nsw", postcode:"2000"},
      {label:"Perth", urlatom:"perth", state:"wa", postcode:"6000"},
      {label:"Melbourne", urlatom:"melbourne", state:"vic", postcode:"3000"},
      {label:"Hobart", urlatom:"hobart", state:"tas", postcode:"7000"},
      {label:"Adelaide", urlatom:"adelaide", state:"sa", postcode:"5000"},
      {label:"Canberra", urlatom:"canberra", state:"act", postcode:"2601"},
      {label:"Brisbane", urlatom:"brisbane-city", state:"qld", postcode:"4000"},
      {label:"Darwin", urlatom:"darwin-city", state:"nt", postcode:"0800"}
    ];

    const suburbs = [
      {label:"Albany", urlatom:"albany", state:"wa", postcode:"6330"},
      {label:"Alice Springs", urlatom:"alice-springs", state:"nt", postcode:"0870"},
      {label:"Balmain", urlatom:"balmain", state:"nsw", postcode:"2041"},
      {label:"Bayview", urlatom:"bayview", state:"nt", postcode:"0820"},
      {label:"Berwick", urlatom:"berwick", state:"vic", postcode:"3806"},
      {label:"Blacktown", urlatom:"blacktown", state:"nsw", postcode:"2148"},
      {label:"Bondi", urlatom:"bondi", state:"nsw", postcode:"2026"},
      {label:"Brighton", urlatom:"brighton", state:"vic", postcode:"3186"},
      {label:"Broadbeach", urlatom:"broadbeach", state:"qld", postcode:"4218"},
      {label:"Brunswick", urlatom:"brunswick", state:"vic", postcode:"3056"},
      {label:"Buderim", urlatom:"buderim", state:"qld", postcode:"4556"},
      {label:"Bunbury", urlatom:"bunbury", state:"wa", postcode:"6230"},
      {label:"Burleigh Heads", urlatom:"burleigh-heads", state:"qld", postcode:"4220"},
      {label:"Burnie", urlatom:"burnie", state:"tas", postcode:"7320"},
      {label:"Caboolture", urlatom:"caboolture", state:"qld", postcode:"4510"},
      {label:"Caloundra", urlatom:"caloundra", state:"qld", postcode:"4551"},
      {label:"Carlton", urlatom:"carlton", state:"vic", postcode:"3053"},
      {label:"Castle Hill", urlatom:"castle-hill", state:"nsw", postcode:"2154"},
      {label:"Chatswood", urlatom:"chatswood", state:"nsw", postcode:"2067"},
      {label:"Clayton", urlatom:"clayton", state:"vic", postcode:"3168"},
      {label:"Coogee", urlatom:"coogee", state:"nsw", postcode:"2034"},
      {label:"Cronulla", urlatom:"cronulla", state:"nsw", postcode:"2230"},
      {label:"Devonport", urlatom:"devonport", state:"tas", postcode:"7310"},
      {label:"Elwood", urlatom:"elwood", state:"vic", postcode:"3184"},
      {label:"Epping", urlatom:"epping", state:"vic", postcode:"3076"},
      {label:"Essendon", urlatom:"essendon", state:"vic", postcode:"3040"},
      {label:"Fitzroy", urlatom:"fitzroy", state:"vic", postcode:"3065"},
      {label:"Frankston", urlatom:"frankston", state:"vic", postcode:"3199"},
      {label:"Fremantle", urlatom:"fremantle", state:"wa", postcode:"6160"},
      {label:"Geraldton", urlatom:"geraldton", state:"wa", postcode:"6530"},
      {label:"Glenelg", urlatom:"glenelg", state:"sa", postcode:"5045"},
      {label:"Griffith", urlatom:"griffith", state:"nsw", postcode:"2680"},
      {label:"Hawthorn", urlatom:"hawthorn", state:"vic", postcode:"3122"},
      {label:"Ipswich", urlatom:"ipswich", state:"qld", postcode:"4305"},
      {label:"Kalgoorlie", urlatom:"kalgoorlie", state:"wa", postcode:"6430"},
      {label:"Kensington", urlatom:"kensington", state:"vic", postcode:"3031"},
      {label:"Kew", urlatom:"kew", state:"vic", postcode:"3101"},
      {label:"Launceston", urlatom:"launceston", state:"tas", postcode:"7250"},
      {label:"Liverpool", urlatom:"liverpool", state:"nsw", postcode:"2170"},
      {label:"Malvern", urlatom:"malvern", state:"vic", postcode:"3144"},
      {label:"Mandurah", urlatom:"mandurah", state:"wa", postcode:"6210"},
      {label:"Manly", urlatom:"manly", state:"nsw", postcode:"2095"},
      {label:"Maroochydore", urlatom:"maroochydore", state:"qld", postcode:"4558"},
      {label:"Mosman", urlatom:"mosman", state:"nsw", postcode:"2088"},
      {label:"North Sydney", urlatom:"north-sydney", state:"nsw", postcode:"2060"},
      {label:"Northcote", urlatom:"northcote", state:"vic", postcode:"3070"},
      {label:"Paddington", urlatom:"paddington", state:"nsw", postcode:"2021"},
      {label:"Parramatta", urlatom:"parramatta", state:"nsw", postcode:"2150"},
      {label:"Port Melbourne", urlatom:"port-melbourne", state:"vic", postcode:"3207"},
      {label:"Redcliffe", urlatom:"redcliffe", state:"qld", postcode:"4020"},
      {label:"Richmond", urlatom:"richmond", state:"vic", postcode:"3121"},
      {label:"Scarborough", urlatom:"scarborough", state:"wa", postcode:"6019"},
      {label:"South Yarra", urlatom:"south-yarra", state:"vic", postcode:"3141"},
      {label:"Southport", urlatom:"southport", state:"qld", postcode:"4215"},
      {label:"St Kilda", urlatom:"st-kilda", state:"vic", postcode:"3182"},
      {label:"Strathfield", urlatom:"strathfield", state:"nsw", postcode:"2135"},
      {label:"Surfers Paradise", urlatom:"surfers-paradise", state:"qld", postcode:"4217"},
      {label:"Surry Hills", urlatom:"surry-hills", state:"nsw", postcode:"2010"},
      {label:"Torquay", urlatom:"torquay", state:"vic", postcode:"3228"},
      {label:"Turner", urlatom:"turner", state:"act", postcode:"2612"},
      {label:"Werribee", urlatom:"werribee", state:"vic", postcode:"3030"},
      {label:"Williamstown", urlatom:"williamstown", state:"vic", postcode:"3016"},
      {label:"Yarraville", urlatom:"yarraville", state:"vic", postcode:"3013"}
    ];

    const propertyTypes = [
      {label:"Houses", queries:"House"},
      {label:"Townhouses", queries:"Townhouse"},
      {label:"Rural", queries:"Rural,Semi-Rural"},
      {label:"Apartment", queries:"Unit,Villa,Apartment,Flat,Studio,Warehouse,Blockofunits,Terrace,Servicedapartment"},
      {label:"Land", queries:"Land"},
      {label:"Commercial", queries:"Commercial"}
    ];

    return (
      <div className="container">
        <h1 className="mt-4">Site Map</h1>
        <h4>Off-Market Property Reports</h4>
        <h5>States and Territories Property Report</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {states.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property/${element.state}`} target='_self'>Real Estate {element.label}</a>
            </li>
          ))}
        </ul>

        <h5>Top Cities Property Report</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {cities.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        <h5>Top Suburbs Property Report</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {suburbs.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        {propertyTypes.map((type, index) => (
          <div>
          <h5>{type.label} Property Report</h5>
          <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
            {states.map((element, index) => (
              <li key={index} className={styles.siteMapItem}>
                <a href={`/property/${element.state}?types=${type.queries}`}>
                  {element.state.toUpperCase()} {type.label} Property Reports
                </a>
              </li>
            ))}
          </ul>
          </div>
        ))}

        <h4>Properties For Sale</h4>
        <h5>States and Territories Property For Sale</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {states.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-sale/${element.state}`}>Real Estate {element.label}</a>
            </li>
          ))}
        </ul>

        <h5>Top Cities Property For Sale</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {cities.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-sale/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        <h5>Top Suburbs Property For Sale</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {suburbs.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-sale/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        {propertyTypes.map((type, index) => (
          <div>
            <h5>{type.label} For Sale</h5>
            <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
              {states.map((element, index) => (
                <li key={index} className={styles.siteMapItem}>
                  <a href={`/property-for-sale/${element.state}?types=${type.queries}`}>
                    {element.state.toUpperCase()} {type.label} For Sale
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}


        <h4>Properties For Rent</h4>
        <h5>States and Territories Property For Rent</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {states.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-rent/${element.state}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        <h5>Top Cities Property For Rent</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {cities.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-rent/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        <h5>Top Suburbs Property For Rent</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {suburbs.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/property-for-rent/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate {element.label}
              </a>
            </li>
          ))}
        </ul>

        {propertyTypes.map((type, index) => (
          <div>
            <h5>{type.label} For Rent</h5>
            <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
              {states.map((element, index) => (
                <li key={index} className={styles.siteMapItem}>
                  <a href={`/property-for-rent/${element.state}?types=${type.queries}`}>
                    {element.state.toUpperCase()} {type.label} For Rent
                  </a>
                </li>
              ))}
            </ul>
          </div>))}


        <h4>Real Estate Agents and Agencies</h4>
        <h5>Real Estate Agents</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {cities.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/real-estate-agents/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate Agents {element.label}
              </a>
            </li>
          ))}
        </ul>

        <h5>Real Estate Agencies</h5>
        <ul className={'pb-4 mb-4 d-flex flex-row pl-0 flex-wrap ' + styles.siteMapList}>
          {cities.map((element, index) => (
            <li key={index} className={styles.siteMapItem}>
              <a href={`/real-estate-agencies/${element.state}/${element.urlatom}-${element.postcode}`}>
                Real Estate Agencies {element.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default StaticSiteMap;
